import React, {useEffect, useState} from 'react';
import {Box, Grid} from '@mui/material';
import {Link} from 'react-router-dom';
import ArrButton from '../../../components/common/arr-button/ArrButton';
import ArrLoadingSpinner from '../../../components/common/arr-loading-spinner/ArrLoadingSpinner';

const LoadingSpinner: React.FC = () => {
  const [showLoader, setShowLoader] = useState(false);
  const [showLoaderOverlay, setShowLoaderOverlay] = useState(false);

  useEffect(() => {
    if (showLoaderOverlay) {
      const timeout = setTimeout(() => {
        setShowLoaderOverlay(false);
      }, 5000); // 5 seconds

      return () => clearTimeout(timeout);
    }
  }, [showLoaderOverlay]);

  return (
    <div style={{marginBottom: '64px', backgroundColor: '#1f2b3d'}}>
      <h1>Loading Spinner</h1>
      <div>
        Loading spinners - express an unspecified wait time or display the
        length of a process.
      </div>
      <Link to="/demo">Return</Link>
      <hr />
      <div style={{marginBottom: '32px'}}>
        <ArrButton
          variant="primary"
          size="large"
          onClick={() => {
            setShowLoader(!showLoader);
          }}
        >
          {showLoader ? 'Hide Loader' : 'Show Loader'}
        </ArrButton>
        <ArrButton
          variant="primary"
          size="large"
          onClick={() => {
            setShowLoaderOverlay(true);
          }}
        >
          {'Show Loader overlay'}
        </ArrButton>
        <br />
        <br />
        <Box>
          <Grid
            container
            spacing={2}
            sx={{paddingTop: '16px', paddingLeft: '15px'}}
          >
            <div>
              <ArrLoadingSpinner show={showLoader} />
            </div>
          </Grid>
        </Box>
      </div>
      <ArrLoadingSpinner
        show={showLoaderOverlay}
        overlay={true}
        isOpen={true}
      />
      <Box>
        <Grid
          container
          spacing={2}
          sx={{paddingTop: '16px', paddingLeft: '15px'}}
        >
          <div>
            Color: white
            <ArrLoadingSpinner show={showLoader} color="secondary" />
          </div>
        </Grid>
      </Box>
    </div>
  );
};

export default LoadingSpinner;
